import React from 'react';
import styled from 'styled-components';
import { merriweather } from 'styles/GlobalStyle';

const H1 = styled.h1`
    font-family: ${merriweather.style.fontFamily};
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.22;
    letter-spacing: 0.36px;
    text-transform: uppercase;
    text-align: left;
    color: ${(props) => props.color || props.theme.colors.primary};
`;

const H2 = styled.h2`
    font-family: ${merriweather.style.fontFamily};
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.22;
    letter-spacing: 0.36px;
    text-transform: uppercase;
    text-align: left;
    color: ${(props) => props.color || props.theme.colors.primary};
`;

const H3 = styled.h3`
    font-family: ${merriweather.style.fontFamily};
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.22;
    letter-spacing: 0.36px;
    text-transform: uppercase;
    text-align: left;
    color: ${(props) => props.color || props.theme.colors.primary};
`;

const H4 = styled.h4`
    font-family: ${merriweather.style.fontFamily};
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.22;
    letter-spacing: 0.36px;
    text-transform: uppercase;
    text-align: left;
    color: ${(props) => props.color || props.theme.colors.primary};
`;

const H5 = styled.h5`
    font-family: ${merriweather.style.fontFamily};
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.22;
    letter-spacing: 0.36px;
    text-transform: uppercase;
    text-align: left;
    color: ${(props) => props.color || props.theme.colors.primary};
`;

const Title = ({ children, level = 2 }) => {
    switch (level) {
        case 1:
            return <H1>{children}</H1>;
        case 2:
            return <H2>{children}</H2>;
        case 3:
            return <H3>{children}</H3>;
        case 4:
            return <H4>{children}</H4>;
        case 5:
            return <H5>{children}</H5>;
        default:
            return <H2>{children}</H2>;
    }
};

export default Title;
